/**
 * Client-side checks for the creative the operator uploads from the «Modal Home App» tab.
 * The backend (kredit-api-MT, PUT /api/app-config/home-modal/content) enforces the same
 * rules; these only give feedback before the upload leaves the browser.
 *
 * The checks themselves live in marketing-image.validator.ts, shared with the banner
 * carousel; this file only pins the modal's rules (exact 900 × 1600, 2 MB).
 */
import {
    checkMarketingImage,
    MarketingImageCheck,
    MarketingImageInfo,
    MARKETING_IMAGE_ACCEPT,
    readImageDimensions,
} from './marketing-image.validator';

export const HOME_MODAL_IMAGE_WIDTH = 900;
export const HOME_MODAL_IMAGE_HEIGHT = 1600;
export const HOME_MODAL_IMAGE_MAX_BYTES = 2 * 1024 * 1024;
/** Value for the file input `accept` attribute. */
export const HOME_MODAL_IMAGE_ACCEPT = MARKETING_IMAGE_ACCEPT;

export type HomeModalImageInfo = MarketingImageInfo;
export type HomeModalImageCheck = MarketingImageCheck;

export { readImageDimensions };

/**
 * Validates mime type, weight and exact dimensions, in that order; the first failure wins.
 * `objectUrl` must have been created from `file` by the caller, who also owns revoking it.
 */
export function checkHomeModalImage(file: File, objectUrl: string): Promise<HomeModalImageCheck> {
    return checkMarketingImage(file, objectUrl, {
        maxBytes: HOME_MODAL_IMAGE_MAX_BYTES,
        exact: { width: HOME_MODAL_IMAGE_WIDTH, height: HOME_MODAL_IMAGE_HEIGHT },
    });
}
